import { render } from "./MenuIcon.vue?vue&type=template&id=0467d0b8&scoped=true"
import script from "./MenuIcon.vue?vue&type=script&lang=js"
export * from "./MenuIcon.vue?vue&type=script&lang=js"

import "./MenuIcon.vue?vue&type=style&index=0&id=0467d0b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0467d0b8"],['__file',"src/components/ChatWidget/ChatIcons/MenuIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0467d0b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0467d0b8', __exports__)) {
    api.reload('0467d0b8', __exports__)
  }
  
  module.hot.accept("./MenuIcon.vue?vue&type=template&id=0467d0b8&scoped=true", () => {
    api.rerender('0467d0b8', render)
  })

}


export default __exports__